module.exports = __webpack_public_path__ + "img/logo-2.2579a782.webp";